import React from "react";

const Skeleton = ({ width = "100%", height = "1rem", circle = false, className = "", style = {} }) => (
  <div
    className={`skeleton ${circle ? "skeleton-circle" : ""} ${className}`.trim()}
    style={{ width, height, ...style }}
  />
);

export default Skeleton;
